module.exports = __webpack_public_path__ + "img/hongmengmeikou.d0d6008d.png";